import React from 'react';

const Features = () => {
  const features = [
    {
      emoji: '💰',
      title: 'Set Your Own Rates',
      description: 'You decide the pricing for your property. Keep 100% of your earnings after platform fees.',
      bgColor: 'bg-gradient-to-br from-emerald-600 to-green-700'
    },
    {
      emoji: '📸',
      title: 'Easy Listing Process',
      description: 'Create beautiful listings in minutes. Upload photos, add details, and start receiving bookings.',
      bgColor: 'bg-gradient-to-br from-stone-600 to-stone-700'
    },
    {
      emoji: '📅',
      title: 'Flexible Calendar',
      description: 'Control your availability. Block dates, set minimum stays, and manage bookings on your terms.',
      bgColor: 'bg-gradient-to-br from-emerald-600 to-teal-700'
    },
    {
      emoji: '💳',
      title: 'Secure Payments',
      description: 'Get paid automatically. Secure payment processing with reliable payouts to your account.',
      bgColor: 'bg-gradient-to-br from-amber-600 to-orange-600'
    },
    {
      emoji: '👥',
      title: 'Verified Travelers',
      description: 'Connect with travelers seeking authentic restorative experiences. All guests are verified.',
      bgColor: 'bg-gradient-to-br from-emerald-600 to-green-700'
    },
    {
      emoji: '📊',
      title: 'Dashboard Analytics',
      description: 'Track your bookings, earnings, and performance with detailed analytics and insights.',
      bgColor: 'bg-gradient-to-br from-emerald-600 to-teal-700'
    }
  ];

  return (
    <div className="mb-12 sm:mb-16 lg:mb-20">
      <section id="features" className="scroll-mt-20">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light text-gray-900 mb-4 sm:mb-6">
            Everything You Need to Succeed
          </h2>
          <p className="text-lg sm:text-xl lg:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed font-light px-4">
            We provide all the tools and support you need to turn your property into a successful restorative retreat. From listing creation to payment processing, we've got you covered.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10">
        {features.map((feature, index) => (
          <div 
            key={index}
            className="group relative bg-white rounded-xl sm:rounded-2xl p-5 sm:p-6 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-emerald-200"
          >
            <div className="flex flex-col h-full">
              {/* Emoji Icon */}
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-emerald-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-emerald-100 transition-colors duration-300 text-2xl sm:text-3xl">
                {feature.emoji}
              </div>
              
              {/* Content */}
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
                {feature.title}
              </h3>
              
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
        </div>
      </section>
    </div>
  );
};

export default Features; 